// extracted by mini-css-extract-plugin
module.exports = {"contener":"End_contener__3s-lC","mainText":"End_mainText__1hMAm","reloadBtn":"End_reloadBtn___ak9I"};